function beforeRequest(context) {
    context.dispatch('SET_PASSWORD_REQUEST_STARTED');
}

function onSuccess(actionContext) {
    const { l10n } = actionContext.getStore('ApplicationContext');

    const message = l10n('dashboard.password.emailSent');

    actionContext.dispatch('SET_PASSWORD_MESSAGE', message);

    actionContext.dispatch('SET_PASSWORD_STATUS_FINISHED', [null]);

    actionContext.dispatch('SET_LOGIN_MODE', 'username');
}

function onFailed(context, { error }) {
    context.dispatch('SET_PASSWORD_STATUS_FINISHED', [error]);
}

export default () => ({
    serviceName: 'requestPassword',
    config: {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        url: '/common/v2/requestPasswordReset',
    },
    beforeRequest,
    onSuccess,
    onFailed,
    onError: onFailed,
    onTimeout: onFailed,
    onFatal: onFailed,
});
